import React, { useState } from 'react';
import { Switch, Redirect, Route } from 'react-router-dom';
import routes from 'routes';
import generalRoutes from 'routes/generalRoutes';
import HandlePageRoutes from 'routes/HandlePageRoutes';
import { useSelector } from 'react-redux';
import { selectLoading } from 'features/loading/loadingSlice';
import Sidebar from 'components/Sidebar';
import ProgressBar from 'react-bootstrap/ProgressBar';
import Home from 'pages/portal/home';
import { isMobile } from 'react-device-detect';
import NotificationComp from 'components/notification/notification';
import HomeRedirector from 'pages/portal/home/home-redirector';
import { selectRoles } from 'features/roles/rolesSlice';
import TopBar from 'components/Topbar';
import { getNavbarStatus } from 'features/sidebar-nav/sidebarNavSlice';
const PortalLayout = () => {
  // const isAuthenticated = useSelector(selectLogin).isAuthenticated;
  const loading = useSelector(selectLoading);
  const { roles } = useSelector(selectRoles);
  const switchToPermission = (roles && roles.switch) || {};
  const { navbar } = useSelector(getNavbarStatus);
  const [showSidebar, setShowSidebar] = useState(navbar);
  // const history = useHistory();
  // let routeFragment = null;
  // // Redirected if not loggedin
  // if (!isAuthenticated) {
  //   routeFragment = (
  //     <Switch>
  //       <Redirect to="/login" />
  //     </Switch>
  //   );
  // } else {
  //   // Show portal routes
  //   routeFragment = (
  //     // <Switch>
  //     <>{HandlePageRoutes(routes, 'portal')}</>
  //     // </Switch>
  //   );
  // }

  return (
    <>
      {loading.show ? (
        <ProgressBar className="global-loader" now={loading.loading} />
      ) : null}

      <TopBar showSidebar={showSidebar} setShowSidebar={setShowSidebar} />
      <div
        className={`main d-flex align-items-stretch ${
          isMobile ? 'mobile' : 'desktop'
        }-wrapper`}
      >
        <NotificationComp />
        <Sidebar showSidebar={showSidebar} setShowSidebar={setShowSidebar} />
        <div id="content">
          <div
            className="h-100 full-height-min rounded-inner print-version-wrapper main-content-container"
            //style={{ pageBreakAfter: 'always' }}
            style={{ paddingTop: '70px' }}
          >
            <Switch>
              <Route
                path={'/'}
                component={HomeRedirector}
                exact={true}
                key={`home-redirector`}
              />
              <Route
                path={'/home'}
                component={Home}
                exact={true}
                key={`home-child`}
              />
              {HandlePageRoutes([...routes, ...generalRoutes], 'portal')}
              <Redirect to="/not-found" />
            </Switch>
          </div>
        </div>
      </div>
    </>
  );
};

export default PortalLayout;
